import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"
}), ___EmotionJSX("line", {
  x1: "4",
  y1: "21",
  x2: "20",
  y2: "21"
}));
export default SVG;